/**
 * Safely resolves backend base URL and storage asset URLs.
 * Prevents "undefined/storage/..." issues when environment variables are missing.
 */
export const getBackendBaseUrl = () => {
  const envBackend = process.env.REACT_APP_PUBLIC_BACKEND_URL
  if (envBackend && envBackend !== 'undefined' && envBackend.trim() !== '') {
    return envBackend.replace(/\/+$/, '')
  }

  const envApi = process.env.REACT_APP_API_URL
  if (envApi && envApi !== 'undefined' && envApi.trim() !== '') {
    return envApi.replace(/\/api\/?$/, '').replace(/\/+$/, '')
  }

  if (typeof window !== 'undefined' && window.location.hostname.includes('bamyanentertainment.de')) {
    return 'https://backend.bamyanentertainment.de'
  }

  return 'http://localhost:8000'
}

export const getStorageImageUrl = (path) => {
  if (!path || typeof path !== 'string' || path.trim() === '' || path === 'undefined' || path === 'null') {
    return null
  }

  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) {
    return path
  }

  const baseUrl = getBackendBaseUrl()
  let clean = path.replace(/^\/+/, '')

  // Ensure 'storage/' prefix for local uploads
  if (!clean.startsWith('storage/') && !clean.startsWith('assets/')) {
    clean = `storage/${clean}`
  }

  return `${baseUrl}/${clean}`
}
